import { useEffect } from "react"

export default function Loader() {

    useEffect(() => {
        document.body.style.overflowY = "hidden";

        return(() => {
            document.body.style.overflowY = "auto";
        })
    }, [])

    return (
        <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center flex-col bg-white bg-opacity-75 z-[999]">
            <div className=" flex justify-center items-center">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-skin-borderLoader"></div>
            </div>
        </div>
    )
}